import * as React from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import { formatDate } from '../../../../ReactComponents/FormatDate';
import { OrderDetailsInvoices } from './OrderDetailsInvoices';

interface OrderDetailsSummaryProps {
    id: string;
    status: string;
    createdDate: string;
    deliveryDate: string;
    paymentType: string;
    invoices: string[];
    invoiceAvailabilityUrl: string;
    invoiceDownloadUrl: string;
    showInvoices: boolean;
}

export const OrderDetailsSummary = (props: OrderDetailsSummaryProps) => {
    const { id, status, createdDate, showInvoices, paymentType } = props;

    return (
        <>
            <h2 className="OrderDetails__ItemsSummaryHeading">{getTranslation(keys['orderSummary.heading'])}</h2>

            <div className="OrderDetails__OrderInfo">
                <div className="OrderDetails__InfoBlocks">
                    <div className="OrderDetails__InfoBlock">
                        <span className="OrderDetails__InfoBlockTitle">{getTranslation(keys['orderSummary.orderDate'])}:</span>
                        <span className="OrderDetails__InfoBlockTitle">{getTranslation(keys['orderSummary.orderNumber'])}:</span>
                        <span className="OrderDetails__InfoBlockTitle">{getTranslation(keys['orderSummary.orderStatus'])}:</span>
                        <span className="OrderDetails__InfoBlockTitle">{getTranslation(keys['orderSummary.paymentInfo'])}:</span>
                    </div>

                    <div className="OrderDetails__InfoBlock">
                        <span className="OrderDetails__InfoBlockValue">{formatDate(createdDate, true)}</span>
                        <span className="OrderDetails__InfoBlockValue">{id}</span>
                        <span className="OrderDetails__InfoBlockValue">{status}</span>
                        <span className="OrderDetails__InfoBlockValue">{paymentType}</span>
                    </div>
                </div>

                {showInvoices && (
                    <OrderDetailsInvoices
                        invoices={props.invoices}
                        orderId={id}
                        availabilityUrl={props.invoiceAvailabilityUrl}
                        downloadUrl={props.invoiceDownloadUrl}
                    />
                )}
            </div>
        </>
    );
};
